import { OrderButton as OrderButtonBase } from "@omni/components/components/Product/ECommerce/components/orderButton/orderButton";

import { OrderButtonComponent } from "@/components/Product/ECommerce/components/orderButton/orderButton.component";

type Props = {};

export const OrderButton = ({ ...attributes }: Props) => {
    return (
        <OrderButtonBase>
            <OrderButtonComponent {...attributes} />
        </OrderButtonBase>
    );
};
